import { Box, Grid } from '@mui/material';
import InputForm from "../../../InputT";
import ParamsPicklist from "../../../../Types/ParamsPicklist";
import SearInputG from "../../../SearchInput"
import SelectMultipleOptionBasket from "../../../SelectMultipleOptionPanier";
import CheckboxF from '../../../ChexBox';
import { useState } from 'react';
import SelectOption from '../../../SelectOption';
// import InputTauxDouble from '../../../InputTauxDouble'; // plus utilisé

let searchParamsIjarah: ParamsPicklist = { CodeAgence: '', Table: "ParamsIjara", Colonne1: "CodeIjara", Colonne2: "LibelleIjara", Colagence: '101', Choix: 22 };
let searchOperat: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 };
let searchWorkflow: ParamsPicklist = { CodeAgence: 'Ijara', Table: "WorkflowEtape", Colonne1: "EtapeID", Colonne2: "LibelleEtape", Colagence: 'CodeFinancement', Choix: 22 };

const Tab1 = (props: { etatG?: boolean, form?: any, Function?: Function }) => {
    const [taxable, setTaxable] = useState(true);

    const handlerChangeIsttax = () => {
        const Istaxable = props.form.getFieldValue("IsTaxable"); // corrigé : IsTaxable
        if (Istaxable) {
            setTaxable(false);
            props.form.setFieldValue('MontantMinTax', 0); // corrigé
        } else {
            setTaxable(true);
            props.form.setFieldValue('MontantMinTax', 0);
        }
    };

    return (
        <div className="tabItem">
            <Box fontStyle="inherit" className="border" width={"85%"} position={"absolute"}>
                <Box fontStyle="inherit" className="border-left">
                    <Grid container spacing={0}>
                        {/* Code Ijarah et Libellé */}
                        <Grid item xs={12} md={6}>
                            <SearInputG
                                notRequired
                                dissabledCode={props.etatG}
                                width={7}
                                Titre="Recherche"
                                label="Code Ijara"
                                name="CodeIjara"
                                Parametre={searchParamsIjarah}
                                form={props.form}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputForm width={3} label="Libellé" type="text" name="LibelleIjara" />
                        </Grid>
                        {/* Ligne 2 */}
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Type de Ijara" type="text" name="TypeIjara" notRequired disabled />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Montant maximum autorisé" type="number" name="MontantMaxAuto" />
                        </Grid>
                         <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Nombre échéances minimum" type="number" name="NbrEchMin" min={1}
                                dependencies={['NbrEchMax']}
                                rules={[
                                    ({ getFieldValue }: any) => ({
                                        validator(_: any, value: any) {
                                            if (value !== undefined && value !== null && value !== '' && Number(value) < 1) {
                                                return Promise.reject(new Error('Le nombre échéances minimal doit être supérieur ou égal à 1'));
                                            }
                                            const max = getFieldValue('NbrEchMax');
                                            if (value !== undefined && value !== null && value !== '' && max !== undefined && max !== null && max !== '' && Number(value) > Number(max)) {
                                                return Promise.reject(new Error('Le nombre échéances minimal doit être inférieur ou égal au maximum'));
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            />
                        </Grid>
        
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Nombre échéances maximum" type="number" name="NbrEchMax" min={1}
                                dependencies={['NbrEchMin']}
                                rules={[
                                    ({ getFieldValue }: any) => ({
                                        validator(_: any, value: any) {
                                            const min = getFieldValue('NbrEchMin');
                                            if (value !== undefined && value !== null && value !== '' && min !== undefined && min !== null && min !== '' && Number(value) < Number(min)) {
                                                return Promise.reject(new Error('Le nombre échéances maximum doit être supérieur ou égal au minimum'));
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Jours constat créance impayée" type="number" name="JrConstatImp" />
                        </Grid>

                        {/* Ligne 3 */}
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Jours constat créance douteuse" type="number" name="JrConstatDouteux" />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Nombre Maximum d'Ijara Autorisé" type="number" name="NbrMaxAuto" />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputForm pourcent width={12} label="Taux Pénalité" type="number" name="TauxP" />
                        </Grid>

                        {/* Ligne 4 */}
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Taux Marge Locative Minimum" type="number" name="TauxMargeLocativeMin" pourcent />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputForm width={12} label="Durée max Contrat (Mois)" type="number" name="DureeContratMoisMax" />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputForm width={12} label="Durée max Amortissement (Mois)" type="number" name="DureeAmortBienMoisMax" />
                        </Grid>

                        {/* Ligne 5 : Taxable + Workflow */}
                        <Grid item xs={12} md={4} display={"flex"} alignItems={"center"}>
                            <CheckboxF
                                onChange={handlerChangeIsttax}
                                width={16}
                                label="Taxable"
                                name="IsTaxable"
                            />
                            <InputForm
                                disabled={taxable}
                                notRequired
                                money
                                width={8}
                                label="Minimum Taxable"
                                type="number"
                                name="MontantMinTax"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectOption
                                width={8}
                                Size={'middle'}
                                label="Workflow Frais"
                                name="WorkflowFrais"
                                Parametre={searchWorkflow}
                            />
                        </Grid>
                                                                             
                        {/* Nouveaux champs (ajoutés) */}
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Montant minimum Promesse" type="number" name="MontantMinPromesse" />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Taux minimum Promesse" type="number" name="TauxMinPromesse" pourcent />
                        </Grid>
                        <Grid item xs={12} md={4} display={"flex"} alignItems={"center"}>
                            <CheckboxF  width={16} label="Garantie Obligatoire" name="IsGarantieObligatoir" />
                        </Grid>

                        {/* Frais de service (existe toujours) */}
                        <Grid item xs={12} style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <SelectMultipleOptionBasket
                                form={props.form}
                                Size="large"
                                width={4}
                                label="Frais de service"
                                name="Frais"
                                Parametre={searchOperat}
                            />
                        </Grid>

                        {/* --- Champs supprimés / commentés --- */}
                        {/*
                        <Grid item xs={12} md={4}>
                            <InputForm width={12} label="Durée max Amortissement (Mois)" name="DureeAmortissementDefaut" />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Valeur Résiduelle Défaut" name="ValeurResiduelleDefaut" />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputTauxDouble required width={12} label="Fond de garantie" name={['TauxFondGarantie', 'MontantFondGarantie']} mode="exclusif" />
                        </Grid>
                        */}
                    </Grid>
                </Box>
            </Box>
        </div>
    );
};

export default Tab1;